import validator from 'validator';

export const urlValidator = {
  isUrl: (url: unknown): boolean => {
    if (typeof url !== 'string') return false;

    return validator.isURL(url, {
      require_protocol: true,
      allow_underscores: true,
      require_tld: false,
    });
  },
};

export const regexValidator = {
  /**
   * 상품 이름에 허용하지 않는 값
   */
  isNotAllowSpecialCharProductName: (value: unknown) => {
    if (typeof value !== 'string') return false;

    return (
      // 특수문자
      /[{}?;|`^<>#$%\\='"]/gi.test(value) ||
      // 이모지
      /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff]|\ud83d[\udc00-\ude4f]|\ud83d[\ude80-\udeff]|\ud83e[\udd00-\uddff]|\ud83e[\ude00-\udeff]|\ud83c[\udf00-\udfff]|\ud83d[\ude00-\ude4f]|\ud83d[\ude80-\udeff])/g.test(
        value,
      )
    );
  },

  /**
   * 문자열에서 특정 값을 포함하는지 체크하는 정규식 모음
   */

  /* 한글 */
  includeHangul: (value: string) => {
    return /[ㄱ-ㅎ가-힣ㅏ-ㅣ]/.test(value);
  },

  /* 특수문자 */
  includeSpecialCharacter: (value: string) => {
    return /[{}?;|`^<>#$%\\='"]/gi.test(value);
  },

  /* 이모지 */
  includeEmoji: (value: string) => {
    return /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff]|\ud83d[\udc00-\ude4f]|\ud83d[\ude80-\udeff]|\ud83e[\udd00-\uddff]|\ud83e[\ude00-\udeff]|\ud83c[\udf00-\udfff]|\ud83d[\ude00-\ude4f]|\ud83d[\ude80-\udeff])/g.test(
      value,
    );
  },
};
